import { createRoute, redirect } from "@tanstack/solid-router";
import { appRoute } from "./route";

/**
 * Space landing: redirects to "Aprender" (`/learn`). The template's list
 * dashboard was retired with the todo-domain contraction.
 */
export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  beforeLoad: () => {
    // oxlint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: "/learn",
      replace: true,
      search: (prev) => prev,
    });
  },
  component: () => null,
});
